
export class EmployeeCashbookDto {
    cashbookId?: number;
    empId:number;
    activityDate: Date;
    amount: string;
    status: boolean;
    createdAt : Date | any;
    createdUser : number;
    updatedAt : Date | any;
    updatedUser : number;
    versionFlag : number;
}

export const EmployeeCashbookDtoDefault : EmployeeCashbookDto = {
    cashbookId: 0,
    empId:0,
    activityDate: new Date() ,
    amount: "",
    status: true,
    createdAt : new Date() ,
    createdUser : 0,
    updatedAt : new Date() ,
    updatedUser : 0,
    versionFlag : 1
};

